(function () {

  'use strict';


  function initShadaniMobileHeader() {

    const header = document.querySelector(
      '[data-shadani-mobile-header]'
    );

    if (!header) return;


    /* =====================================================
       MOBILE CHECK
       ===================================================== */

    const isMobile = () => {
      return window.matchMedia(
        '(max-width: 767px)'
      ).matches;
    };


    /* =====================================================
       SEARCH PHRASES
       ===================================================== */

    const searchInput =
      header.querySelector(
        '[data-shadani-search-input]'
      );


    const phrases = [

      window.shadaniMobileSettings?.search1 ||
        'CANDY CRAVING.....',

      window.shadaniMobileSettings?.search2 ||
        'MANGO SLICE.....',

      window.shadaniMobileSettings?.search3 ||
        'AAM PAPAD.....',

      window.shadaniMobileSettings?.search4 ||
        'DIGESTIVE GOLI.....',

      window.shadaniMobileSettings?.search5 ||
        'PAAN MIX SAUNF.....'

    ];


    let phraseIndex = 0;
    let typingTimer = null;


    function typeSearchPhrase() {

      if (!searchInput) return;

      if (document.activeElement === searchInput) {
        return;
      }


      const phrase = phrases[phraseIndex];

      let character = 0;

      clearInterval(typingTimer);


      searchInput.placeholder = '';


      typingTimer = setInterval(function () {

        if (
          document.activeElement === searchInput
        ) {

          clearInterval(typingTimer);

          return;
        }


        searchInput.placeholder =
          phrase.substring(0, character);

        character++;


        if (character > phrase.length) {

          clearInterval(typingTimer);

          setTimeout(function () {

            phraseIndex =
              (phraseIndex + 1) %
              phrases.length;

            typeSearchPhrase();

          }, 1300);

        }

      }, 55);

    }


    typeSearchPhrase();


    /* =====================================================
   SEARCH BUTTON + SEARCH MODE
   ===================================================== */

const bottomSearch =
  header.querySelector(
    '[data-shadani-bottom-search]'
  );

const mobileSearch =
  header.querySelector(
    '.shadani-mobile-search'
  );

const searchSuggestions =
  header.querySelector(
    '[data-shadani-search-suggestions]'
  );

const searchBackdrop =
  header.querySelector(
    '[data-shadani-search-backdrop]'
  );


function openSearchMode() {

  if (!searchInput) return;


  /*
   * Make header visible
   */

  header.classList.remove(
    'shadani-mobile-hidden'
  );


  /*
   * Activate search bar
   */

  if (mobileSearch) {

    mobileSearch.classList.add(
      'search-active'
    );

  }


  /*
   * Activate bottom Search icon
   */

  if (bottomSearch) {

    bottomSearch.classList.add(
      'active'
    );

  }


  /*
   * Fade website
   */

  document.body.classList.add(
    'shadani-search-mode'
  );


  /*
   * Show suggestions
   */

  if (searchSuggestions) {

    searchSuggestions.classList.add(
      'is-visible'
    );

  }


  /*
   * Show backdrop
   */

  if (searchBackdrop) {

    searchBackdrop.classList.add(
      'is-visible'
    );

  }


  /*
   * Focus search
   */

  setTimeout(function () {

    searchInput.focus();

  }, 180);

}


function closeSearchMode() {

  if (mobileSearch) {

    mobileSearch.classList.remove(
      'search-active'
    );

  }


  if (bottomSearch) {

    bottomSearch.classList.remove(
      'active'
    );

  }


  document.body.classList.remove(
    'shadani-search-mode'
  );


  if (searchSuggestions) {

    searchSuggestions.classList.remove(
      'is-visible'
    );

  }


  if (searchBackdrop) {

    searchBackdrop.classList.remove(
      'is-visible'
    );

  }

}


/*
 * CLOSE SEARCH SUGGESTIONS BUTTON
 */

const searchCloseButton =
  header.querySelector('[data-shadani-search-close]');

if (searchCloseButton) {
  searchCloseButton.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    // Hide the suggestions panel
    if (searchSuggestions) {
      searchSuggestions.classList.remove('is-visible');
    }

    // Remove the dimmed-page backdrop
    if (searchBackdrop) {
      searchBackdrop.classList.remove('is-visible');
    }

    // Restore the normal page appearance
    document.body.classList.remove('shadani-search-mode');
  });
}


/*
 * Bottom Search button
 */

if (bottomSearch) {

  bottomSearch.addEventListener(
    'click',
    function () {

      if (!isMobile()) return;

      openSearchMode();

    }
  );

}


/*
 * Clicking backdrop closes search
 */

if (searchBackdrop) {

  searchBackdrop.addEventListener(
    'click',
    function () {

      closeSearchMode();

    }
  );

}


/*
 * Search suggestions
 */

const searchSuggestionButtons =
  header.querySelectorAll(
    '[data-search-suggestion]'
  );


searchSuggestionButtons.forEach(
  function (button) {

    button.addEventListener(
      'click',
      function () {

        const value =
          button.getAttribute(
            'data-search-suggestion'
          );


        if (!searchInput || !value) {
          return;
        }


        searchInput.value = value;

        searchInput.placeholder = value;


        /*
         * Hide suggestions after selection
         */

        if (searchSuggestions) {

          searchSuggestions.classList.remove(
            'is-visible'
          );

        }


        /*
         * Keep search active
         */

        searchInput.focus();

      }
    );

  }
);


/*
 * When user types, keep search active
 */

if (searchInput) {

  searchInput.addEventListener(
    'focus',
    function () {

      if (!isMobile()) return;

      openSearchMode();

    }
  );


  searchInput.addEventListener(
    'input',
    function () {

      if (!isMobile()) return;

      if (searchSuggestions) {

        searchSuggestions.classList.add(
          'is-visible'
        );

      }

    }
  );

}


/*
 * ESC closes search
 */

document.addEventListener(
  'keydown',
  function (event) {

    if (
      event.key === 'Escape' &&
      document.body.classList.contains(
        'shadani-search-mode'
      )
    ) {

      closeSearchMode();

    }

  }
);
    /* =====================================================
       BELL / OFFER POPUP
       ===================================================== */

    const notificationButton =
      header.querySelector(
        '[data-shadani-notification-open]'
      );


    const notificationBox =
      header.querySelector(
        '[data-shadani-notification-box]'
      );


    const notificationClose =
      header.querySelector(
        '[data-shadani-notification-close]'
      );


    function openOfferPopup() {

      if (!notificationBox) return;


      notificationBox.classList.add(
        'is-visible'
      );


      notificationBox.setAttribute(
        'aria-hidden',
        'false'
      );


      if (notificationButton) {

        notificationButton.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      /*
       * Stop background scrolling
       */

      document.body.style.overflow = 'hidden';

    }


    function closeOfferPopup() {

      if (!notificationBox) return;


      notificationBox.classList.remove(
        'is-visible'
      );


      notificationBox.setAttribute(
        'aria-hidden',
        'true'
      );


      if (notificationButton) {

        notificationButton.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      document.body.style.overflow = '';

    }


    if (notificationButton) {

      notificationButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          openOfferPopup();

        }
      );

    }


    if (notificationClose) {

      notificationClose.addEventListener(
        'click',
        function () {

          closeOfferPopup();

        }
      );

    }


    /*
     * Click outside popup
     */

    if (notificationBox) {

      notificationBox.addEventListener(
        'click',
        function (event) {

          if (
            event.target === notificationBox
          ) {

            closeOfferPopup();

          }

        }
      );

    }


    /*
     * ESC closes popup
     */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          notificationBox &&
          notificationBox.classList.contains(
            'is-visible'
          )
        ) {

          closeOfferPopup();

        }

      }
    );


    /* =====================================================
       COPY COUPON
       ===================================================== */

    const copyButtons =
      header.querySelectorAll(
        '[data-copy-code]'
      );


    copyButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        async function () {

          const code =
            button.getAttribute(
              'data-copy-code'
            );


          if (!code) return;


          let copied = false;


          /*
           * Modern Clipboard API
           */

          try {

            if (
              navigator.clipboard &&
              window.isSecureContext
            ) {

              await navigator.clipboard.writeText(
                code
              );

              copied = true;

            }

          } catch (error) {

            copied = false;

          }


          /*
           * Older browser fallback
           */

          if (!copied) {

            try {

              const textarea =
                document.createElement(
                  'textarea'
                );

              textarea.value = code;

              textarea.style.position =
                'fixed';

              textarea.style.opacity = '0';

              document.body.appendChild(
                textarea
              );

              textarea.select();

              document.execCommand(
                'copy'
              );

              textarea.remove();

              copied = true;

            } catch (error) {

              copied = false;

            }

          }


          /*
           * Button animation
           */

          if (copied) {

            const originalText =
              button.textContent;

            button.textContent =
              'COPIED ✓';

            button.classList.add(
              'copied'
            );


            setTimeout(function () {

              button.textContent =
                originalText;

              button.classList.remove(
                'copied'
              );

            }, 1800);

          }

        }
      );

    });


    /* =====================================================
       MENU
       ===================================================== */

    const menuButton =
      header.querySelector(
        '[data-shadani-menu]'
      );


    if (menuButton) {

      menuButton.addEventListener(
        'click',
        function () {

          /*
           * Theme's existing mobile menu
           */

          const existingMenuButton =
            document.querySelector(
              '.tp-offcanvas-open-btn'
            );


          if (existingMenuButton) {

            existingMenuButton.click();

            return;

          }


          const alternativeMenuButton =
            document.querySelector(
              '[data-offcanvas-open]'
            );


          if (alternativeMenuButton) {

            alternativeMenuButton.click();

          }

        }
      );

    }


    /* =====================================================
       ACTIVE BOTTOM NAV
       ===================================================== */

    const navItems =
      header.querySelectorAll(
        '[data-nav-item]'
      );


    const currentPath =
      window.location.pathname;


    navItems.forEach(function (item) {

      const type =
        item.getAttribute(
          'data-nav-item'
        );


      let active = false;


      if (
        type === 'home' &&
        (
          currentPath === '/' ||
          currentPath === ''
        )
      ) {

        active = true;

      }


      if (
        type === 'search' &&
        currentPath.startsWith(
          '/search'
        )
      ) {

        active = true;

      }


      if (
        type === 'wishlist' &&
        currentPath.includes(
          'wishlist'
        )
      ) {

        active = true;

      }


      if (
        type === 'account' &&
        (
          currentPath.includes(
            '/account'
          ) ||
          currentPath.includes(
            '/customer'
          )
        )
      ) {

        active = true;

      }


      if (active) {

        item.classList.add(
          'active'
        );

      }

    });


    /* =====================================================
       SCROLL HIDE / SHOW
       ===================================================== */

    let lastScrollY =
      window.scrollY || 0;

    let ticking = false;

    let scrollDownDistance = 0;

    const hideAfter =
      70;


    function handleScroll() {
      if (
  document.body.classList.contains(
    'shadani-search-mode'
  )
) {

  header.classList.remove(
    'shadani-mobile-hidden'
  );

  ticking = false;

  return;

}

      if (!isMobile()) {

        header.classList.remove(
          'shadani-mobile-hidden'
        );

        lastScrollY =
          window.scrollY || 0;

        ticking = false;

        return;

      }


      const currentScrollY =
        window.scrollY || 0;


      const difference =
        currentScrollY - lastScrollY;


      /*
       * At very top:
       * always show both bars
       */

      if (currentScrollY <= 25) {

        header.classList.remove(
          'shadani-mobile-hidden'
        );

        scrollDownDistance = 0;

        lastScrollY =
          currentScrollY;

        ticking = false;

        return;

      }


      /*
       * SCROLLING DOWN
       */

      if (difference > 0) {

        scrollDownDistance +=
          difference;


        /*
         * Wait until user has moved
         * enough before hiding.
         */

        if (
          scrollDownDistance >=
          hideAfter
        ) {

          header.classList.add(
            'shadani-mobile-hidden'
          );

        }

      }


      /*
       * SCROLLING UP
       */

      else if (difference < 0) {

        scrollDownDistance = 0;


        /*
         * Immediately bring both
         * header and bottom nav back.
         */

        header.classList.remove(
          'shadani-mobile-hidden'
        );

      }


      lastScrollY =
        currentScrollY;

      ticking = false;

    }


    window.addEventListener(
      'scroll',
      function () {

        if (!ticking) {

          window.requestAnimationFrame(
            handleScroll
          );

          ticking = true;

        }

      },
      {
        passive: true
      }
    );


    /* =====================================================
       RESIZE
       ===================================================== */

    window.addEventListener(
      'resize',
      function () {

        if (!isMobile()) {

          header.classList.remove(
            'shadani-mobile-hidden'
          );

        }

      }
    );

  }


  /* =======================================================
     INITIALIZE
     ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initShadaniMobileHeader
    );

  } else {

    initShadaniMobileHeader();

  }

})();